import environment from '../config/environment.js'

export default {
    install(Vue) {
        Vue.prototype.$env = environment
    }
}
